import { render } from "./AppImagem.vue?vue&type=template&id=f410a32a&scoped=true"
import script from "./AppImagem.vue?vue&type=script&lang=js"
export * from "./AppImagem.vue?vue&type=script&lang=js"

import "./AppImagem.vue?vue&type=style&index=0&id=f410a32a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f410a32a"]])

export default __exports__